export default {
    getId: () => {
        let me = $cookies.get('me');
        if (me) {
            return me.id;
        }
        return 0;
    },
    get: () => {
        let me = $cookies.get('me');
        return me;
    },
}